import { Component } from '@verndale/core';

import Dropdown from '../../components/dropdown';
import DatePicker from '../../components/datepicker';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      inputs: this.el.querySelectorAll('.custom-form__field input[type=text]'),
      radioGroups: this.el.querySelectorAll('.custom-form__field--radio-group'),
      dropdowns: this.el.querySelectorAll('.custom-form__field select'),
      datepickers: this.el.querySelectorAll(
        '.custom-form__field input[type=date]'
      )
    };

    this.el.setAttribute('novalidate', 'novalidate');

    //Init dropdowns
    this.dom.dropdowns.forEach(dropdown => {
      dropdown.parentNode.parentNode.classList.add('field_dropdown');
      new Dropdown(dropdown);
    });

    //Init datepickers
    this.dom.datepickers.forEach(datepicker => {
      new DatePicker(datepicker);
    });
  }

  addListeners() {
    this.dom.inputs.forEach(input => {
      if (input.value) {
        input.parentNode.classList.add('active');
      }

      input.addEventListener('focus', e => {
        e.target.parentNode.classList.add('active');
      });

      input.addEventListener('blur', e => {
        if (!e.target.value) {
          e.target.parentNode.classList.remove('active');
        }
      });
    });

    this.el.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(e) {
    if (!this.validateForm()) {
      e.preventDefault();
    }
  }

  validateForm() {
    let isValid = true;

    this.dom.inputs.forEach(input => {
      input.parentNode.classList.remove('error');
      if (input.required && !input.value.trim()) {
        input.parentNode.classList.add('error');
        if (isValid) {
          input.focus();
        }
        isValid = false;
      }
    });

    this.dom.radioGroups.forEach(radioGroup => {
      radioGroup.classList.remove('error');
      const requiredRadio = [...radioGroup.querySelectorAll('input')].find(
        input => input.required
      );
      if (requiredRadio) {
        if (
          ![...radioGroup.querySelectorAll('input')].some(
            input => input.checked
          )
        ) {
          radioGroup.classList.add('error');
          if (isValid) {
            requiredRadio.focus();
          }
          isValid = false;
          return;
        }
      }
    });

    return isValid;
  }
}

export default Module;
